import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [bootstrap, setBootstrap] = useState(null);
  const [settings, setSettings] = useState(null);
  const [roleCode, setRoleCode] = useState(
    () => localStorage.getItem("rs_role") || "intake");
  const [validationOpen, setValidationOpen] = useState(false);

  useEffect(() => {
    api.bootstrap().then(setBootstrap).catch(() => {});
    api.getSettings().then(setSettings).catch(() => {});
  }, []);

  const setRole = (code) => {
    setRoleCode(code);
    localStorage.setItem("rs_role", code);
  };

  const refreshSettings = () => api.getSettings().then(setSettings).catch(() => {});
  const persona = bootstrap?.personas?.find((p) => p.role_code === roleCode);

  const value = {
    bootstrap,
    roleCode,
    setRole,
    persona,
    validationOpen,
    setValidationOpen,
    operatingMode: settings?.operating_mode || "ACTIVE",
    shadowLabel: settings?.shadow_label,
    refreshSettings,
    disclaimer: bootstrap?.disclaimer ||
      "RequiSure — Concept Prototype 0.1 | Developed by Inforno HealthTech | Synthetic Demonstration Environment | For Validation Only",
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
